var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7886 9.23776C26.1182 8.86423 26.2793 8.37351 26.25 7.87546C26.2134 7.37741 25.9863 6.91599 25.6128 6.5864C25.2393 6.25681 24.7485 6.09568 24.2505 6.12497C23.7524 6.16159 23.291 6.38864 22.9614 6.76218L11.1548 20.2534L6.95068 16.0493C6.21826 15.3169 5.03174 15.3169 4.29932 16.0493C3.94775 16.4009 3.75 16.8769 3.75 17.375C3.75 17.873 3.94775 18.3491 4.29932 18.7007L9.92432 24.3257C10.2905 24.6919 10.7959 24.8969 11.3086 24.875C11.8286 24.8603 12.3193 24.626 12.6636 24.2378L25.7886 9.23776Z",
    fill: "#E0BA56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMision);
export default __webpack_public_path__ + "static/media/checkMision.9bea247e94c60cddbb94965a8d689e58.svg";
export { ForwardRef as ReactComponent };